// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ebtXJ2Up_OJBi9XJg0c9 {
  height: auto !important;
  padding: 0 !important;
}`, "",{"version":3,"sources":["webpack://./js/view/component/table-columns/dataset-actions/component/styles.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,qBAAA;AACF","sourcesContent":[".menu_item {\n  height: auto !important;\n  padding: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menu_item": `ebtXJ2Up_OJBi9XJg0c9`
};
export default ___CSS_LOADER_EXPORT___;
